import { stockSelection } from '@/views/stock/stockSelection'
import { getIndexQuotes } from '@/utils/indexQuotes'
import { marketSession } from '@/utils/marketClock'

export { marketSession }

export const marketIndexes = {
  cn: [['s_sh000001', '上证指数'], ['s_sz399001', '深证成指'], ['s_sz399006', '创业板指']],
  hk: [['s_r_hkHSI', '恒生指数'], ['s_r_hkHSCEI', '国企指数'], ['s_r_hkHSCCI', '红筹指数']],
  us: [['t_us.DJI', '道琼斯'], ['t_us.IXIC', '纳斯达克'], ['t_us.INX', '标普500']]
}

// Match H5 index symbols, requesting only the current footer market.
export async function getMarketIndexQuotes(market) {
  return getIndexQuotes(marketIndexes[market].map(([code]) => code).join(','))
}

export function footerMarket(route) {
  const market = route.path === '/stocks' ? stockSelection(route.query || {}).market : (route.params || {}).market
  return market === 'hk' || market === 'us' ? market : 'cn'
}

export function indexQuotes(market, quotes) {
  return marketIndexes[market].map(([code, name]) => {
    const row = quotes[code]
    const number = value => value !== '' && value != null && Number.isFinite(Number(value)) ? Number(value) : null
    const simple = code.startsWith('s_')
    return { code, name, price: row ? number(row[3]) : null, change: row ? number(row[simple ? 4 : 31]) : null, percent: row ? number(row[simple ? 5 : 32]) : null, time: !simple && row ? row[30] : null }
  })
}
